/**
 * Хранилище состояния пользователя
 */
export default ({ authService }) => {
	return {
		namespaced: true,
		state: () => {
			return {
				user: authService.getUser()
			}
		},
		getters: {
			/**
			 * Имя пользователя
			 * @param {Object} state
			 * @return {String}
			 */
			username(state) {
				return state.user.email || "Гость"
			},

			/**
			 * Получить айди зашедшего пользователя
			 * @param {Object} state
			 * @returns {Number}
			 */
			userId(state) {
				return state.user.id || null
			},

			/**
			 * Токен пользователя
			 * @param {Object} state
			 * @return {String|null}
			 */
			token(state) {
				return state.user.token || null
			},

			/**
			 * Пользователь залогинен
			 * @return {Boolean}
			 */
			isLogged(state) {
				return !!state.user.token
			}
		},
		mutations: {
			/**
			 * Установить пользователя
			 * @param {Object} state
			 * @param {Object} user
			 */
			setUser(state, user) {
				state.user = user
			}
		},
		actions: {
			/**
			 * Пройти авторизацию
			 * @param {Object} context
			 * @param {Object} params
			 */
			async refreshUser({ commit }) {
				await authService.auth()
				commit("setUser", authService.getUser())
			},

			/**
			 * Залогиниться
			 * @param {Object} context
			 * @param {Object} params
			 */
			async login({ commit }, { email, password }) {
				const user = await authService.login(email, password)

				commit("setUser", user)
			},

			/**
			 * Разлогиниться
			 * @param {Object} context
			 */
			async logout({ commit }) {
				await authService.logout()

				commit("setUser", {})
			}
		}
	}
}
